<div class="filter-input-container" [class]="'size-' + size">
  <label *ngIf="label" class="filter-label">{{ label }}</label>
  <div [class]="'filter-box size-' + size" [style.width]="width" [class.error]="hasError" [class.disabled]="disabled">
    <i class="fal fa-search search-icon"></i>
    <input
      type="text"
      [ngModel]="model"
      (ngModelChange)="onInput($event)"
      (keydown)="onKeydown($event)"
      [placeholder]="placeholder"
      [attr.disabled]="disabled ? '' : null"
    />
    <i
      *ngIf="hasValue && !disabled"
      class="fal fa-times clear-icon"
      (click)="onClear()"
      title="Clear"
    ></i>
  </div>
  <div *ngIf="hasError && errorText" class="error-text">
    <i class="fal fa-exclamation-circle error-icon"></i>
    {{ errorText }}
  </div>
</div>

